import {observer} from "mobx-react";
import * as React from "react";
import Icon from "../Icon/Icon";
import LottieAnimation from "../LottieAnimation/LottieAnimation";
import {FormVerificationTexts} from "../../scenes/Forms/screens/SignUpForm/FormVerification/FormVerificationTexts";


interface ILocalState {
    filesAnimationController: any
}
interface IProps {
    store: any;
    propertyName: string;
    formPageName: string;
    onFileRemoved: () => void;


}

@observer
export default class FileInputUploadedSuccessfully extends React.Component<IProps> {
    public state: ILocalState = {
        filesAnimationController: {}
    };

    public render() {
        const {propertyName} = this.props;
        setTimeout(() => {
            const newState = this.state;
            newState.filesAnimationController[propertyName] = true;
            this.setState(newState);
        }, 1700);
        {return this.state.filesAnimationController[propertyName]? this.renderFileUploaded() : this.renderFileUploadedSuccessfullyAnimation()}

    };

    private renderFileUploadedSuccessfullyAnimation = () => {
        return (
            <div className="files-container">
                <LottieAnimation animationName={'blueCheckmark'} />
            </div>
        )
    };

    private renderFileUploaded = () => {
        const {propertyName} = this.props;
        if (propertyName === "idImage") {
            return this.renderIdImageSuccessfullyUploaded()
        } else if([FormVerificationTexts.propertyNames.SIGNUP_PDF, "coveragePdfFile", "upgradePdfFile", "lendioId", "sbaFirstPdfFile", "sbaSecondPdfFile","sbaThirdPdfFile"].includes(propertyName)) {
            return this.renderPDFSuccessfullyUploaded()
        }else {
            return null
        }
    }

    private renderIdImageSuccessfullyUploaded = () => {
        const {store, formPageName, propertyName, onFileRemoved} = this.props;
        return (
            <div className="file-uploaded-container">
                <div className="image-container">
                    <img src={store.formInput[formPageName][propertyName]}/>
                </div>
                {store.allowImageDelete? <div className="remove" onClick={onFileRemoved}>Delete</div> : null}
            </div>
        )
    }

    private renderPDFSuccessfullyUploaded = () => {
        const {onFileRemoved} = this.props;
        return(
            <div className="file-uploaded-container">
                <div className="pdf-icon-container">
                    <Icon icon={'done'}/>
                </div>
                <div className="remove" onClick={onFileRemoved}>Delete</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormFileInput/FileInputUploadedSuccessfully.tsx